import type { RadioGroupProps } from '@base-ui/react';

import { Fieldset as BaseFieldset, RadioGroup as BaseRadioGroup } from '@base-ui/react';

type Props<Value> = RadioGroupProps<Value>;

export const RadioGroup = <Value,>({ ...delegated }: Props<Value>) => {
  return <BaseFieldset.Root render={<BaseRadioGroup {...delegated} />} />;
};
